import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import Image from 'next/image';
import { useWalletSREP } from 'structure/staking/hooks/useStakingAPI';
import { parseSREP } from 'structure/staking/utils/parseSREP';
import { useConnection } from 'wagmi';
import { ProjectSocialLink } from './ProjectSocialLink';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'baseui/spinner';

interface IProjectOverview {
  project: {
    iconUrl: string;
    title: string;
    description: string;
    tokenSymbol: string;
    telegram?: string;
    discord?: string;
    blog?: string;
    twitter?: string;
  };
}

const ProjectOverview = ({ project }: IProjectOverview) => {
  const account = useConnection();
  const { t } = useTranslation('common');

  const walletSREP = useWalletSREP({
    walletAddress: account.address as `0x${string}`,
    depositTokenSymbol: project.tokenSymbol,
    query: {
      enabled: !!account.address,
    },
  });

  const srep = parseSREP(walletSREP.data?.srep || '0').toNumber();

  return (
    <>
      <div className='w-1/2 rounded-2xl bg-[#141314] p-8  max-lg:w-full'>
        <div className='flex items-start'>
          <Image
            src={project.iconUrl}
            alt='icon'
            width={60}
            height={60}
            className='rounded border border-gray-600 bg-black'
          />
          <div className='flex flex-col px-4'>
            <Typography className='text-3xl'>{project.title}</Typography>
            <Typography className='mt-3 text-xs text-[#9EABCA]'>
              {project.description}
            </Typography>
          </div>
        </div>
        <div className='my-6'>
          <Typography className='text-sm text-[#9EABCA]'>
            {project.tokenSymbol === 'SFI' ? t('SFIREP') : project.tokenSymbol}
          </Typography>
        </div>
        <div className='flex items-center justify-between'>
          <div>
            {walletSREP.isFetched ? (
              <Typography className='text-4xl text-white'>
                {srep.toLocaleString()}
              </Typography>
            ) : (
              <Spinner $size='14px' $borderWidth='3px' />
            )}
          </div>
          <div className='flex items-center gap-1'>
            <ProjectSocialLink icon='telegram' link={project.telegram} />
            <ProjectSocialLink icon='medium' link={project.blog} />
            <ProjectSocialLink icon='discord' link={project.discord} />
            <ProjectSocialLink icon='twitter' link={project.twitter} />
          </div>
        </div>
      </div>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default ProjectOverview;
